import { render } from "./EditYacht.vue?vue&type=template&id=6f88fc16"
import script from "./EditYacht.vue?vue&type=script&lang=ts"
export * from "./EditYacht.vue?vue&type=script&lang=ts"
script.render = render

export default script